import { useRouter } from 'next/router'
import { useFreeTrial } from '@mc/free-trial'
import { useTranslation } from '@mc/i18n'
import Nav from '@mc/navigation'
import { paths } from '@mc/paths'
import { NavigationEvents } from '@mc/track-event'
import { trackBrowseSkillsCatalogCTAClick } from './utils'

export const MobileMenu = ({
  newForBusinessPageEnabled = false,
}: {
  newForBusinessPageEnabled?: boolean
}) => {
  const { t } = useTranslation('@mc/next')
  const { trial } = useFreeTrial()
  const { pathname, query } = useRouter()

  return (
    <>
      {newForBusinessPageEnabled && (
        <Nav.MenuLink href={paths.enterpriseHowItWorks}>
          {t('nav.cta.howItWorks')}
        </Nav.MenuLink>
      )}

      {trial.eligible && (
        <Nav.MenuLink href={paths.checkoutGift()}>
          {t('nav.cta.gift')}
        </Nav.MenuLink>
      )}

      <Nav.MenuLink
        href={paths.enterpriseSkillsLibrary}
        onClick={trackBrowseSkillsCatalogCTAClick({
          action: t('nav.cta.browseSkillsLibrary'),
          level: NavigationEvents.LEVELS.SECONDARY,
          pathname,
          query,
        })}
      >
        {t('nav.cta.browseSkillsLibrary')}
      </Nav.MenuLink>

      <Nav.MenuLink href={paths.helpCenter}>
        {t('nav.cta.support')}
      </Nav.MenuLink>

      <Nav.MenuLink href={paths.logIn()}>{t('nav.cta.login')}</Nav.MenuLink>
    </>
  )
}
